<template>
  <div class="main-container billing-table-height">
    <vk-offcanvas-content>
      <vk-offcanvas flipped overlay stuck :show.sync="showUpdate">
        <vk-offcanvas-close @click="showUpdate = false"></vk-offcanvas-close>
        <arnergy-product-update
          :updateData="this.updateParams"
        ></arnergy-product-update>
      </vk-offcanvas>
    </vk-offcanvas-content>
    <div style="width: 100%">
      <h3 class="pagin_style">
        Showing
        {{
          paginationInfo.total > 0
            ? `${paginationInfo.first} - ${paginationInfo.last}
          ${paginationInfo.ofText} ${paginationInfo.total} ${
                paginationInfo.total > 1 ? "Devices" : "Device"
              }`
            : "no device"
        }}
      </h3>
      <el-input
        style="width: 30%"
        class="el-input el-input--prefix"
        placeholder="Type Customers ID"
        prefix-icon="el-icon-search"
        v-model="searchTerm"
      ></el-input>
      <vue-good-table
        :lineNumbers="true"
        :columns="fields"
        :rows="getUsers"
        :isLoading="isLoadingVGT"
        :search-options="{
          enabled: true,
          searchFn: searchTable,
          externalQuery: searchTerm
        }"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'producttype'">
            {{ props.row.producttype ? props.row.producttype : "----" }}
          </span>

          <span v-if="props.column.field == 'productdescription'">
            {{
              props.row.productdescription
                ? props.row.productdescription
                : "----"
            }}
          </span>

          <span v-if="props.column.field == 'amountos'">
            {{ props.row.amountos ? props.row.amountos : "----" }}
          </span>

          <span v-if="props.column.field == 'monthlyamountlo'">
            {{ props.row.monthlyamountlo ? props.row.monthlyamountlo : "----" }}
          </span>

          <span v-if="props.column.field == 'tenurelo'">
            {{ props.row.tenurelo ? props.row.tenurelo : "----" }}
          </span>

          <span v-if="props.column.field == 'actions'">
            <div class="action_style">
              <a-dropdown :trigger="['click']">
                <p class="ant-dropdown-link ellipsis_style">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </p>
                <template slot="overlay">
                  <a-menu>
                    <a-menu-item class="action_update" key="0">
                      <p
                        class="fontawesome_style"
                        @click="
                          updateBilling(
                            props.row.id,
                            props.row.producttype,
                            props.row.productdescription,
                            props.row.amountos,
                            props.row.monthlyamountlo,
                            props.row.tenurelo
                          )
                        "
                      >
                        <i class="fas fa-edit"> </i> Edit
                      </p>
                    </a-menu-item>
                    <a-menu-divider />
                    <a-menu-item class="action_delete" key="1">
                      <p
                        class="fontawesome_style"
                        @click="
                          deleteModal(props.row.id, props.row.producttype)
                        "
                      >
                        <i class="fa fa-trash"> </i> Delete
                      </p>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </div>
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            @paginated-info="paginationInfo = $event"
          ></grey-pagination>
        </template>
      </vue-good-table>

      <modal
        width="500px"
        height="auto"
        name="my-first-modal"
        style="border-radius: 28px !important"
        class="first-modal"
      >
        <div class="form">
          <form name="myForm">
            <p class="triangle">
              <i
                class="fa fa-exclamation-triangle fa-3x"
                style="color:red; background-color: pink; border-radius: 50%; width: 45px; height: 47px; margin: 16px;"
                aria-hidden="true"
              ></i>
            </p>
            <h4>
              Are you sure you want to delete this product record?
            </h4>
            <p style="text-align: center;">"{{ userProductType }}"</p>

            <div class="row">
              <button type="submit" class="button-cancel" @click="cancel">
                Cancel
              </button>
              <button
                type="submit"
                class="button-delete"
                @click.prevent="deleteDevice(idSelected)"
              >
                Delete
              </button>
            </div>
          </form>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import UpdateArnergyProduct from "../AdminOnboarding/UpdateArnergyProduct.vue";
import {
  Offcanvas,
  OffcanvasClose,
  OffcanvasContent
} from "vuikit/lib/offcanvas";
import {
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton
} from "element-ui";
import moment from "moment";
moment.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

const items = [];
export default {
  name: "ListArnergyProduct",
  components: {
    "vk-offcanvas-content": OffcanvasContent,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "el-autocomplete": Autocomplete,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-radio": Radio,
    "el-radio-group": RadioGroup,
    "el-radio-button": RadioButton,
    "arnergy-product-update": UpdateArnergyProduct
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      paginationInfo: {},
      updateParams: {
        id: "",
        productType: "",
        productDescription: "",
        amountOs: "",
        monthlyAmountLo: "",
        tenureLo: "",
        showUpdate: false
      },
      showUpdate: false,
      paginatedInfo: {},
      searchTerm: "",
      isLoadingVGT: true,
      editOffCanvas: false,
      isLoading: false,
      deleteReason: "",
      idSelected: "",
      userProductType: "",
      disableButton: "",
      userID: "",
      regParams: {},
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [
        {
          field: "producttype",
          label: "Product Type",
          sortable: "true"
        },
        {
          field: "productdescription",
          label: "Product Description",
          sortable: "true"
        },
        {
          field: "amountos",
          label: "OS Amount (₦)",
          sortable: "true"
        },
        {
          field: "monthlyamountlo",
          label: "LO Amount (₦)",
          sortable: "true"
        },
        {
          field: "tenurelo",
          label: "Tenure LO",
          sortable: "true"
        },
        {
          field: "actions",
          label: "",
          sortable: "false"
        }
      ],
      getUsers: "",
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },
  // computed: {
  //   ...mapGetters(["getUsers"]),
  //   sortOptions() {
  //     return this.fields
  //       .filter(f => f.sortable)
  //       .map(f => {
  //         return {
  //           text: f.label,
  //           value: f.key
  //         };
  //       });
  //   }
  // },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
    deleteModal(dataID, dataProductType) {
      this.idSelected = dataID;
      this.userProductType = dataProductType;
      this.show();
    },
    updateBilling(
      Id,
      producttype,
      productdescription,
      amountos,
      monthlyamountlo,
      tenurelo
    ) {
      this.updateParams.id = Id;
      this.updateParams.productType = producttype;
      this.updateParams.productDescription = productdescription;
      this.updateParams.amountOs = amountos;
      this.updateParams.monthlyAmountLo = monthlyamountlo;
      this.updateParams.tenureLo = tenurelo;
      this.showUpdate = true;
    },
    cancel() {
      this.idSelected = "";
      this.userProductType = "";
      this.hide();
    },
    deleteDevice(userIds) {
      console.log(userIds);
      const HTTP = this.$httpUtils.FASTHTTP;
      const url = `/product/delete-products?id=${userIds}`;
      HTTP.delete(url)
        .then(res => {
          this.showSuccessMsg({ message: "Device Deleted!" });
          this.init();
          this.hide();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    },
    init() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let url = `/product/arnergyproducts`;
      HTTP.get(url)
        .then(response => {
          this.getUsers = response.data;
          this.isLoadingVGT = false;
        })
        .catch(error => {
          this.showErrorMsg({ message: "Error occured at our end!" });
        });
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.ellipsis_style {
  font-size: 30px;
  color: #1388bd;
}
.pagin_style {
  color: #85878d;
}
.action_delete {
  color: red;
}
.action_delete:hover {
  background-color: red;
  color: whitesmoke;
}
.action_update {
  color: #1388bd;
}
.action_update:hover {
  background-color: #1388bd;
  color: whitesmoke;
}
.fontawesome_style {
  font-family: "Poppins", Arial, sans-serif !important;
  font-weight: 600;
  font-size: 14px;
}
.el-input__inner {
  border-radius: 10px;
  /* width: 360px; */
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.triangle {
  /* background-color: red; */
  width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.form {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.button-delete:hover {
  padding: 5px;
  color: white;
  border-color: rgb(146, 1, 1);
  background: rgb(146, 1, 1);
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: grey;
  border: 1px solid grey;
  background: white;
  width: 49%;
  border-radius: 8px;
}

.button-cancel:hover {
  padding: 5px;
  color: white;
  border: 1px solid grey;
  background-color: #85878d;
  width: 49%;
  border-radius: 8px;
}

table th,
table th span {
  font-size: 0.7em;
}
.billing-table-height {
  height: calc(100vh - 250px);
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/AdminOnboarding/ListArnergyProduct.vue